"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAreaSelection = void 0;
var isAreaSelection = function (selection) { return "image" in selection; };
exports.isAreaSelection = isAreaSelection;
